import "./index.scss";
import React, {
  FunctionComponent,
  useState,
  useEffect,
  ReactNode,
  FormEvent,
} from "react";

import { START_DATE_SELECTION_PATH } from "../../routing/paths";
import ButtonOptions from "../ButtonOptions";
import { useStripe } from "@stripe/react-stripe-js";
import { Stripe } from "@stripe/stripe-js";
import { logEvent } from "../../shared/eventLogger";

type CheckoutFormProps = {
  changePath: Function;
  submitPaymentIntent: Function;
  updatePaymentIntent: Function;
  setIsProcessingPayment: Function;
  paymentIntentSecret: string;
  children: ReactNode;
  totalAmount: number | null;
  handlePaymentCompleted: Function;
};

const CheckouForm: FunctionComponent<CheckoutFormProps> = ({
  changePath,
  submitPaymentIntent,
  updatePaymentIntent,
  setIsProcessingPayment,
  paymentIntentSecret,
  children,
  totalAmount,
  handlePaymentCompleted,
}: CheckoutFormProps) => {
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(false);

  // Stripe references
  const stripe = useStripe() as Stripe;

  useEffect(() => {
    if (totalAmount) {
      if (!paymentIntentSecret) submitPaymentIntent(totalAmount);
      else updatePaymentIntent(totalAmount);
    }
  }, [submitPaymentIntent, updatePaymentIntent, paymentIntentSecret, totalAmount]);

  const handlePaymentSubmit = async (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    setProcessing(true);
    setIsProcessingPayment(true);
    const payload = await stripe.confirmCardPayment(paymentIntentSecret);

    if (payload.error) {
      setError(`Payment failed - ${payload.error.message}`);
    } else {
      setError("");
      handlePaymentCompleted(paymentIntentSecret);
      logEvent("purchase", {
        transaction_id: paymentIntentSecret.split("_secret_")[0],
        currency: "USD",
        value: totalAmount!,
      });
    }
    setProcessing(false);
    setIsProcessingPayment(false);
  };

  return (
    <form id="payment-form" onSubmit={handlePaymentSubmit}>
      <div className="form-row">
        {error && (
          <div className="card-errors" role="alert">
            {error}
          </div>
        )}
      </div>
      {children}
      <ButtonOptions
        changePath={changePath}
        previous={START_DATE_SELECTION_PATH}
        handleSubmit={() => {}}
        submitText="Complete Order"
        disabled={processing}
        hideOnEnterText
      />
    </form>
  );
};

export default CheckouForm;
